import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { email } from '@config';
import Logo from './logo';

const StyledFooter = styled.footer`
  position: relative;
  width: 100%;
  padding: 72px 0 32px;
  background-color: var(--paper-soft);
  border-top: 1px solid var(--line);
`;

const StyledInner = styled.div`
  ${({ theme }) => theme.mixins.container};
  display: grid;
  grid-template-columns: 1.6fr 1fr 1.4fr;
  gap: 48px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 36px;
  }
`;

const StyledBrand = styled.div`
  max-width: 380px;

  .brand-tagline {
    margin: 18px 0 16px;
    color: var(--text-soft);
    font-size: var(--fz-md);
  }

  .brand-mail {
    display: block;
    color: var(--text-soft);
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
    word-break: break-all;
  }
`;

const StyledCol = styled.div`
  h4 {
    margin: 0 0 18px;
    color: var(--text);
    font-family: var(--font-mono);
    font-size: var(--fz-xxs);
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }

  ul {
    ${({ theme }) => theme.mixins.resetList};
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  a {
    color: var(--text-soft);
    font-size: var(--fz-sm);

    &:hover,
    &:focus {
      color: var(--blue);
    }
  }
`;

const StyledBottom = styled.div`
  ${({ theme }) => theme.mixins.container};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 56px;
  padding-top: 24px;
  border-top: 1px solid var(--line);
  color: var(--text-mute);
  font-size: var(--fz-xs);

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
`;

const sections = [
  { name: 'Главная', url: '/' },
  { name: 'Услуги', url: '/services' },
  { name: 'О специалисте', url: '/about' },
  { name: 'Контакты', url: '/contacts' },
];

const documents = [
  { name: 'Политика конфиденциальности', url: '/privacy' },
  { name: 'Обработка персональных данных', url: '/personal-data' },
];

const Footer = () => (
  <StyledFooter>
    <StyledInner>
      <StyledBrand>
        <Logo size={40} />
        <p className="brand-tagline">Разработка программного обеспечения современного уровня</p>
        <span className="brand-mail">{email}</span>
      </StyledBrand>

      <StyledCol>
        <h4>Разделы</h4>
        <ul>
          {sections.map(({ name, url }) => (
            <li key={url}>
              <Link to={url}>{name}</Link>
            </li>
          ))}
        </ul>
      </StyledCol>

      <StyledCol>
        <h4>Документы</h4>
        <ul>
          {documents.map(({ name, url }) => (
            <li key={url}>
              <Link to={url}>{name}</Link>
            </li>
          ))}
        </ul>
      </StyledCol>
    </StyledInner>

    <StyledBottom>
      <span>
        © {new Date().getFullYear()} SMART-KVADRAT · ИП Пушкарева Мария Викторовна
      </span>
      <span>Разработка ПО, мобильных приложений и веб-сервисов</span>
    </StyledBottom>
  </StyledFooter>
);

export default Footer;
